import type { NextRequest } from "next/server";

export const locales = [
    "ar",
    "bg",
    "by",
    "cs",
    "de",
    "dk",
    "ee",
    "en",
    "es",
    "fi",
    "fr",
    "he",
    "hr",
    "hu",
    "it",
    "lt",
    "nl",
    "no",
    "pl",
    "pt",
    "ro",
    "ru",
    "sk",
    "sl",
    "sr",
    "sv",
    "tr",
    "uk",
    "zh",
] as const;

export type LocaleType = (typeof locales)[number];
export const headerLangKey = "locale";

export const defaultLocale: LocaleType = "en";

export const i18nConfig = {
    locales,
    defaultLocale,
    noPrefix: true,
    // biome-ignore lint:
    localeDetector: (request: NextRequest, config: any) => {
        const obj = Object.fromEntries(request.cookies);
        const locale = obj?.NEXT_LOCALE;
        if (locale && config.locales.includes(locale)) return locale;

        return config.defaultLocale;
    },
};

export const isRtl = (locale: string) => {
    const rtlLocales: Partial<LocaleType[]> = ["ar", "he"];
    return rtlLocales.includes(locale as LocaleType);
};
